module.exports = __webpack_public_path__ + "static/media/slogan.c81b3b76.png";